<template>
    <div class="container">
        <div class="goods-list-wrap" @scroll="handleScroll">
            <div class="goods-list-box">
                <div class="empty" v-if="empty">暂无数据</div>
                <div
                    class="goods-list-item"
                    v-for="(item, index) of list"
                    :key="index"
                    @click="toDetail(item)"
                >
                    <div class="list-item">
                        <div class="main">
                            <div class="left">
                                <div class="type">
                                    {{ item.goods_1_data.type_name }}
                                </div>
                                <div class="title">
                                    {{ item.goods_1_data.goods_name }}
                                </div>
                                <div style="margin: 16px 0">
                                    <img
                                        v-if="item.goods_1_data.is_star"
                                        class="tag"
                                        src="@/assets/images/goods/v4/list/icon-star-tag.png"
                                    />
                                    <img
                                        class="img-goods"
                                        :src="item.goods_1_data.mobile_thumb"
                                    />
                                </div>
                            </div>
                            <div class="right">
                                <div class="type">
                                    {{ item.goods_2_data.type_name }}
                                </div>
                                <div class="title">
                                    {{ item.goods_2_data.goods_name }}
                                </div>
                                <div style="margin: 16px 0">
                                    <img
                                        class="img-goods"
                                        :src="item.goods_2_data.mobile_thumb"
                                    />
                                </div>
                            </div>

                            <img
                                class="img-pk"
                                src="@/assets/images/goods/v4/list/icon-pk.png"
                            />
                        </div>
                        <div class="bottom">
                            <div class="updated-time">
                                更新时间：{{ item.updated_at?.split(" ")[0].replaceAll("-", "/") }}
                            </div>
                            <div
                                class="close-btn"
                                @click.stop="deleteItem(item)"
                            >
                                取消收藏
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span>确认要取消收藏吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleClose">确 定</el-button>
            </span>
        </el-dialog> -->
    </div>
</template>
<script>
import oApi from "@/js/goodsv4.js";
import { Toast, Dialog } from "vant";
import Vue from "vue";
// import { Dialog } from "element-ui";

Vue.use(Dialog);

export default {
    name: "list",
    components: {},
    data() {
        return {
            list: [],
            params: {
                page: 1,
                limit: 10,
            },
            total: 0,
            refreshDisabled: true, // 是否禁用下拉刷新
            refreshing: false, // 是否处于下拉刷新状态
            loading: false, // 是否处于加载状态
            finished: false, // 数据是否已全部加载完毕
            dialogVisible: false, // 是否显示dialog
            delItem: {}, // 要删除的item
            empty: false,
        };
    },
    created() {
        this.query = this.$route.query;
        window.$init(() => {
            Promise.all([this.getListData()])
                .then(() => {
                    // this.setFontSize();
                    this.isShow = true;
                })
                .catch((err) => {
                    console.log(err, "created err");
                });
        });
    },
    mounted() {},
    methods: {
        goBack() {
            this.$router.back();
        },
        // 获取收藏列表
        getListData() {
            // 收藏页面列表
            oApi.getGoodsShareCompareLists(this.params)
                .then((res) => {
                    console.log("getGoodsShareCompareLists", res.result.list);
                    this.list = this.list.concat(res.result.list);
                    this.total = res.result.total;
                    this.empty = res.result.list.length == 0;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 下拉刷新
        onRefresh() {
            console.log("onRefresh");
            this.list = [];
            this.params.page = 1;
            this.refreshing = true;
            this.getListData();
            this.refreshing = false;
            this.finished = false;
        },
        // 触底刷新
        handleScroll(event) {
            const { scrollTop, scrollHeight, clientHeight } = event.target;
            // 检查是否滚动到底部
            if (scrollTop + clientHeight >= scrollHeight) {
                console.warn("滚动到底部了！", this.list.length, this.total);
                if (this.list.length == 0) {
                    return;
                }
                if (this.list.length < this.total) {
                    this.params.page += 1;
                    this.getListData();
                    console.log(1);
                } else {
                    console.log("停止调用");
                    this.finished = true;
                    console.log(2);
                }
            }
        },
        toDetail(item) {
            console.log("前往编辑", item);
            localStorage.setItem("pad_goods_item", JSON.stringify(item));
            let id = [0, item.id];
            this.$router.push(`/goods/pk/index?id=${JSON.stringify(id)}`);
        },
        deleteItem(item) {
            console.log("删除", item);
            this.dialogVisible = true;
            this.delItem = item;
            Dialog.alert({
                title: "提示",
                message: "确认要取消收藏吗？",
                showCancelButton: true,
            })
                .then(() => {
                    this.handleClose();
                })
                .catch(() => {});
        },
        handleClose() {
            console.log("调用删除接口", this.delItem);
            oApi.deleteGoodsShareCompare({ id: this.delItem.id })
                .then((res) => {
                    console.log("删除成功", res);
                    Toast.success("删除成功");
                    this.onRefresh();
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.dialogVisible = false;
                });
            //
            //
            // this.list.splice(this.list.indexOf(this.delItem), 1);
            // this.onRefresh()
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./collect.scss";
</style>
